//
//
//
//
//
//

export default {
  name: 'FingerprintSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1500
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data () {
    return {
      ringsNum: 9,
      containerPadding: 2
    }
  },

  computed: {
    outerRingSize () {
      return this.size - this.containerPadding * 2
    },

    spinnerStyle () {
      return {
        height: `${this.size}px`,
        width: `${this.size}px`,
        padding: `${this.containerPadding}px`
      }
    },

    ringStyle () {
      return {
        borderTopColor: this.color,
        animationDuration: `${this.animationDuration}ms`
      }
    },

    ringsStyles () {
      const ringsStyles = []
      const ringBase = this.outerRingSize / (this.ringsNum)
      const ringInc = ringBase

      for (let i = 1; i <= this.ringsNum; i++) {
        let style = Object.assign({
          animationDelay: `${i * 50}ms`,
          height: `${ringBase + (i - 1) * ringInc}px`,
          width: `${ringBase + (i - 1) * ringInc}px`
        }, this.ringStyle)
        ringsStyles.push(style)
      }

      return ringsStyles
    }
  }
}
